export { OBJECT_BACKGROUND_COLOR_REFERENCE } from '../Hasp/properties/v2/shared.js';

/**
 * Read the effective main background color from an openHASP object.
 *
 * The real Designer objects expose the v2 style API. The fallbacks keep this
 * helper useful for plain objects used by import/export callers and tests.
 */
export function getObjectBackgroundColor(object) {
  if (!object) return null;

  const resolved = object.styleProp?.('main', 'bg_color');
  if (resolved != null) return resolved;

  const style = object.style?.('main');
  if (style?.bg_color != null) return style.bg_color;
  if (object.bg_color != null) return object.bg_color;

  return object.parts?.main?.states?.default?.properties?.bg_color ?? null;
}

/** Convert a #RRGGBB/#RRGGBBAA Designer color to Home Assistant's RGB array. */
export function backgroundColorToRgb(value) {
  if (typeof value !== 'string') return null;
  const match = value.trim().match(/^#([0-9a-f]{6})(?:[0-9a-f]{2})?$/i);
  if (!match) return null;

  const hex = match[1];
  return [
    Number.parseInt(hex.slice(0, 2), 16),
    Number.parseInt(hex.slice(2, 4), 16),
    Number.parseInt(hex.slice(4, 6), 16),
  ];
}

export function objectBackgroundColorToRgb(object) {
  return backgroundColorToRgb(getObjectBackgroundColor(object));
}
